import axios from '@/jslib/axios'

export const getReferralBonusList = (params) => {
  return axios({
    method: 'get',
    url: '/admin/account/referral/bonus',
    params,
  })
}
export const getQuarterMonthList= params => {
  return axios({
    method: 'get',
    url: '/admin/account/referral/quarter',
    params
  })
}
export const getQuarterSummary = params => {
  return axios({
    method: 'get',
    url: '/admin/account/referral/quarter/summary',
    params
  })
}
export const getDetailQuarterList = params => {
  return axios({
    method: 'get',
    url: '/admin/account/referral/quarter/list',
    params
  })
}
